import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const CARD = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            cardId: 'cardId',
            type: 'type',
            masked: 'masked',
            billing: 'billing'
        }),
        [MODE_PROD]: Object.freeze({
            cardId: 'ci',
            type: 't',
            masked: 'm',
            billing: 'b'
        })
    })
})()

export const BILLING = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            firstName: 'firstName',
            lastName: 'lastName',
            address: 'address',
            city: 'city',
            state: 'state',
            zip: 'zip',
            phoneNumber: 'phoneNumber',
            country: 'country'
        }),
        [MODE_PROD]: Object.freeze({
            firstName: 'fn',
            lastName: 'ln',
            address: 'a',
            city: 'c',
            state: 's',
            zip: 'z',
            phoneNumber: 'pn',
            country: 'co'
        })
    })
})()

export const REFUND = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            subtotal: 's',
            deliveryFee: 'd',
            adminFee: 'a',
            tax: 't',
            total: 'to'
        }),
        [MODE_PROD]: Object.freeze({
            subtotal: 's',
            deliveryFee: 'd',
            adminFee: 'a',
            tax: 't',
            total: 'to'
        })
    })
})()

export const FRAUD = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            name: 'name'
        }),
        [MODE_PROD]: Object.freeze({
            name: 'n'
        })
    })
})()

export const PAYMENT_PROCESSOR = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            transId: 'transId',
            submitTimeUTC: 'submitTimeUTC',
            refTransId: 'refTransId',
            transactionType: 'transactionType',
            transactionStatus: 'transactionStatus',
            responseCode: 'responseCode',
            responseReasonCode: 'responseReasonCode',
            responseReasonDescription: 'responseReasonDescription',
            authCode: 'authCode',
            AVSResponse: 'AVSResponse',
            cardCodeResponse: 'cardCodeResponse',
            CAVVResponse: 'CAVVResponse',
            FDSFilterAction: 'FDSFilterAction',
            fraud: 'fraud',
            requestedAmount: 'requestedAmount',
            authAmount: 'authAmount',
            settleAmount: 'settleAmount',
            cardType: 'cardType',
            mobileDeviceId: 'mobileDeviceId',
            customerProfileId: 'customerProfileId',
            customerPaymentProfileId: 'customerPaymentProfileId',
            clientId: 'clientId'
        }),
        [MODE_PROD]: Object.freeze({
            transId: 'ti',
            submitTimeUTC: 'stu',
            refTransId: 'rti',
            transactionType: 'tt',
            transactionStatus: 'ts',
            responseCode: 'rc',
            responseReasonCode: 'rrc',
            responseReasonDescription: 'rrd',
            authCode: 'ac',
            AVSResponse: 'ar',
            cardCodeResponse: 'ccr',
            CAVVResponse: 'cr',
            FDSFilterAction: 'ffa',
            fraud: 'f',
            requestedAmount: 'ra',
            authAmount: 'aa',
            settleAmount: 'sa',
            cardType: 'ct',
            mobileDeviceId: 'mbi',
            customerProfileId: 'cpi',
            customerPaymentProfileId: 'cppi',
            clientId: 'ci'
        })
    })
})()

export const ORDER_TRANSACTIONS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            modifiedAt: 'modifiedAt',
            isActive: 'isActive',
            isCaptured: 'isCaptured',
            isSettled: 'isSettled',
            placedBy: 'placedBy',
            storeId: 'storeId',
            card: 'card',
            status: 'status',
            markedAsFraud: 'markedAsFraud',
            chargedTotal: 'chargedTotal',
            refund: 'refund',
            paymentProcessor: 'paymentProcessor'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'ca',
            modifiedAt: 'ma',
            isActive: 'ia',
            isCaptured: 'ic',
            isSettled: 'is',
            placedBy: 'pb',
            storeId: 'si',
            card: 'c',
            status: 's',
            markedAsFraud: 'maf',
            chargedTotal: 'ct',
            refund: 'r',
            paymentProcessor: 'pp'
        })
    })
})()
